// Consumo de créditos de IA no mês.
import { Zap } from 'lucide-react'
import { useAiUsage } from '../ai/api'
import { ErrorState, Loading } from '../../ui'

const MONTHS = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']

export default function CreditsCard({ companyId }: { companyId: string }) {
  const q = useAiUsage(companyId)
  const u = q.data
  const pct = u && u.limit > 0 ? Math.min(100, Math.round((u.used / u.limit) * 100)) : 0
  return (
    <section className="card">
      <div className="card-head">
        <span className="ic amber"><Zap size={18} /></span>
        <div>
          <h3>Créditos de IA do mês</h3>
          <p className="small muted">Cada texto gerado ou pergunta ao assistente usa 1 crédito. Repetir o mesmo pedido não gasta.</p>
        </div>
      </div>
      {q.isLoading && <Loading lines={1} />}
      {q.error && <ErrorState error={q.error} onRetry={() => q.refetch()} />}
      {u && (
        <div className="stack" style={{ gap: 8 }}>
          <div className="row between">
            <span className="strong">{u.used} de {u.limit} usados</span>
            <span className="small muted">{MONTHS[Number(u.month.slice(5, 7)) - 1]}</span>
          </div>
          <div className="progress" role="progressbar" aria-valuenow={u.used} aria-valuemin={0} aria-valuemax={u.limit}>
            <span style={{ width: `${pct}%`, background: pct >= 90 ? 'var(--amber)' : undefined }} />
          </div>
          <p className="small muted">{u.left === 0 ? 'Os créditos acabaram. Eles renovam no dia 1º.' : `Restam ${u.left}. Os créditos renovam no dia 1º.`}</p>
        </div>
      )}
    </section>
  )
}
